function M(r, o) {
  let e;
  typeof r == "number" ? e = { rows: r, cols: o ?? 2 } : e = r;
  const n = Math.max(1, Math.floor(e.rows)), a = Math.max(1, Math.floor(e.cols)), l = e.headers ?? Array.from({ length: a }, (t, s) => `Header ${s + 1}`), c = e.alignment ?? Array(a).fill("left"), f = l.slice(0, a).map((t) => t || " ").join(" | "), m = l.slice(0, a).map((t) => Math.max(3, (t || " ").length)), d = Array.from({ length: a }, (t, s) => {
    const h = c[s] ?? "left", i = m[s];
    return h === "center" ? ":" + "-".repeat(Math.max(1, i - 2)) + ":" : h === "right" ? "-".repeat(Math.max(2, i - 1)) + ":" : "-".repeat(i);
  }).join(" | "), u = Array.from(
    { length: n },
    () => m.map((t) => " ".repeat(t)).join(" | ")
  ).map((t) => `| ${t} |`).join(`
`);
  return `${e.headerColor ? `<!-- mz-table: header=${e.headerColor} -->
` : ""}| ${f} |
| ${d} |
${u}
`;
}
function g(r, o) {
  if (r === null)
    return null;
  const e = r.trim();
  if (!e)
    return Math.max(1, o);
  const n = Number.parseInt(e, 10);
  return Number.isNaN(n) || n < 1 ? Math.max(1, o) : n;
}
export {
  M as b,
  g as r
};
//# sourceMappingURL=table-DtH1DJ20.js.map
